import { styled } from "goober";
import { Box } from "../../Box";
import { Button } from "../../Button";
import { Input } from "../../Input";
import { PressButton } from "../../PressButton";
import { Text } from "../../Text";
import { fieldOutline } from "../../fieldOutline";

export function DomainField({
  value,
  onChange,
  isNew,
}: {
  value: string;
  onChange: (value: string) => void;
  isNew: boolean;
}) {
  return (
    <Field>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md">Domain</Text>
      </Box>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={isNew ? "yourcompany.com" : undefined}
        style={{ width: "100%" }}
      />
      <Box horizontal={8} top={6}>
        <Text variant="text-small" color="var(--text-secondary)">
          People with this email domain sign in with SSO. Leave blank to allow
          any domain.
        </Text>
      </Box>
    </Field>
  );
}

export const HelperRow = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 6px 8px 0;
`;

export const FieldActions = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
`;

export const FieldLink = styled(PressButton)`
  color: var(--text-secondary);
  &:hover {
    color: var(--text-primary);
  }
`;

export const Field = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const MonoTextarea = styled("textarea")`
  width: 100%;
  padding: 8px 12px;
  background-color: var(--surface-primary);
  color: var(--text-primary);
  border: 0;
  ${fieldOutline("&:focus")}
  border-radius: 8px;
  font-family: var(--font-mono);
  font-weight: 350;
  font-size: 11px;
  line-height: 20px;
  resize: none;
  &::placeholder {
    opacity: 0.3;
  }
  &:focus {
    &::placeholder {
      opacity: 0.6;
    }
  }
`;

export const CertTextarea = styled(MonoTextarea)`
  min-height: 80px;
`;

const KeptBox = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 4px 4px 4px 12px;
  background-color: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 8px;
`;

// Saved values that stay server-side can't be shown, only kept or replaced.
export function KeptValue({
  label,
  onReplace,
}: {
  label: string;
  onReplace: () => void;
}) {
  return (
    <KeptBox>
      <Text
        variant="text-regular"
        color="var(--text-secondary)"
        style={{ flex: 1 }}
      >
        {label}
      </Text>
      <Button size="m" variant="secondary" onClick={onReplace}>
        Replace
      </Button>
    </KeptBox>
  );
}
